import { useTranslation } from 'react-i18next';

import { IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface CopyToClipboardButtonProps {
  text: string;
  alignment?: false | 'end' | 'start';
}

const CopyToClipboardButton = ({ text, alignment }: CopyToClipboardButtonProps) => {
  const { t } = useTranslation();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
  };

  return (
    <IconButton
      aria-label={t('copyToClipboard')}
      onClick={() => copyToClipboard()}
      edge={alignment}
    >
      <ContentCopyIcon />
    </IconButton>
  );
};

export default CopyToClipboardButton;
